module.exports = __webpack_public_path__ + "static/customer-ee0f3df0e519b8e5373ae59b4c362aac.png";